import React, { useState } from 'react';
import api from '../api/api';

const Unassignp = ({ handlePateintsModalClose, 
  Patients,
  fetchRoomData,
  darkMode,fetchSignIndata,
  handleUnassignPateint ,
  handleAlarmData
}) => {
  const [selected, setSelected] = useState(null);
  // const [loading, setLoading] = useState(false);
  // const practiseid = window.getPracticeId();
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      {/* Popup Box */}
      <div className="relative flex flex-col  w-[35%] bg-white  rounded-[8px] shadow-lg text-left ">
        <div className={`px-3 py-3 border-b-[1.6px] ${darkMode?'bg-[#333333]':''} flex items-center justify-between`} style={{borderTopLeftRadius:'8px' ,borderTopRightRadius:'8px'}}>
          <div className='font-inter text-[18px]'>Patients List</div>
          <button
            className="text-black text-[30px]"
            onClick={handlePateintsModalClose}
          >
            &times;
          </button>
        </div>
        <div className={`w-full p-4 pt-6 ${darkMode?'bg-[#333333]':""} rounded-br-[8px] rounded-bl-[8px]`}>
          {/* Check if Patients has data to render */}
          {Patients && Patients.length === 0 ? (
            <p>No patients assigned.</p>
          ) : (
            <ul>
              {Patients.map(patient => (
                <li key={patient.id} className={`patient-item font-inter ${darkMode?'bg-[#374151CC] ':""} border-[1.5px] py-3 rounded-[8px] cursor-pointer my-1  px-4 flex items-center justify-between`}>
                  <div className='flex gap-2'>
                  <div className='font-inter'>{patient.firstname} {patient.lastname} </div> <div className='text-[#6B7280]'>#{patient.patientid}</div>

                  </div>
                  <div onClick={()=>handleUnassignPateint({Pateints:patient})} className="px-2 py-1 rounded text-sm cursor-pointer border-[1.5px] font-inter">
                    Unassign
                  </div>
                </li>
              ))}
            </ul>
          )}
             <div className='mb-2 mt-10 '>
  {/*  */}
  {/*  */}
  <div className='w-full flex  justify-center gap-4 '>
  <div onClick={() => {handleAlarmData({ PateintData: Patients[0] },"false"); setSelected('mute');  }}   className={`px-4 w-[50%] font-inter border-[1.5px]  text-center rounded py-2 cursor-pointer  ${
          selected === 'mute' ? 'bg-[#000000] text-white' : ' border-gray-200'
        }`}>
  Mute
 </div>
 <div onClick={() => {handleAlarmData({ PateintData: Patients[0] },"true");  setSelected('off');  }}  className={`px-4 w-[50%] font-inter border-[1.5px] text-center rounded py-2 cursor-pointer ${
          selected === 'off' ? 'bg-[#000000] text-white' : ' border-gray-200'
        }`}>
  OFF
 </div>
  </div>
 
        </div>
        </div>
     
      </div>
    </div>
  );
};

export default Unassignp;
